<template>
  <div class="page">
    <empty description="暂无练习信息" v-if="libList.length <= 0">
      <van-button round plain hairline type="default" class="bottom-button" @click="$router.push({path:'/user/kefu'})">联系我们~</van-button>
    </empty>
    <div class="apply-item" v-for="item in libList" :key="item.id" @click="toView(item)">
      <div class="info">
        <div class="name">{{ item.libName }}</div>
        <div class="btn" @click="toView(item)">开始做题</div>
      </div>

      <div class="item-conf">
        <div class="num">试题数量：{{ item.totalNum }}</div>
        <div class="time" v-if="item.expireTime != -1 && curTime<item.expireTime">有效期至：{{ fromatDate(item.expireTime) }}</div>
        <div class="time" v-else-if="item.expireTime != -1 && curTime>item.expireTime">已过期</div>
      </div>

    </div>
  </div>
</template>
<script>
import { Empty,Button as VanButton } from "vant";
import { fetchLibs } from "@api/exam";
import { decrypt } from "@utils/crypto";
import dayjs from "dayjs";

export default {
  components: { Empty,VanButton },
  data: function() {
    return {
      curTime: new Date().getTime() / 1000,
      libList: []
    };
  },
  created() {
    this.fetchLibList();
  },
  methods: {
    toView(item) {
      if (item.expireTime != -1 && this.curTime > item.expireTime) {
        this.$dialog.toast({ mes: "对不起，您的练习已过期！" });
      } else {
        this.$router.push({ path: `/exam/lib/view/${item.id}` });
      }
    },
    fetchLibList() {
      fetchLibs().then(res => {
        let result = JSON.parse(decrypt(res.result));
        this.$set(this, "libList", result || []);
      });
    },
    fromatDate(created) {
      return dayjs.unix(created).format("YYYY-MM-DD");
    }
  }
};
</script>
<style scoped lang="scss">
.page {
  background-color: #F5F5F5 !important;
  height: 100vh;
  .bottom-button{
    width: 160px;
    height: 40px;
  }
}

.apply-item {
  display: block;
  background-color: #fff;
  border-radius: 5px;
  margin: 10px 10px;
  padding: 8px 10px 8px;

  .info{
    display: flex;
    justify-content: space-between;
    .name {
      line-height: 32px;
      font-weight: bold;
    }
  }
  .btn{
    background-color: #00aaea;
    color: #fff;
    padding: 0 20px;
    border-radius: 20px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }

}

.item-conf {
  color: #909399;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  min-width: 250px;
  margin-top:10px;

  .time,.num {
    height: 30px;
    line-height: 30px;
  }
}
</style>
